export default "__VITE_ASSET__B71U8GEK__"